"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.GIFT_ACTIONS_LIST = void 0;

var _gifting = require("./gifting.types");

var GIFT_ACTIONS_LIST = [{
  id: _gifting.GiftActions.AllAllowed,
  label: 'Accept, Exchange or Donate their gift'
}, {
  id: _gifting.GiftActions.AcceptOrExchange,
  label: 'Accept or Exchange'
}, {
  id: _gifting.GiftActions.AcceptOrDonate,
  label: 'Accept or Donate'
}, {
  id: _gifting.GiftActions.OnlyAccept,
  label: 'Only Accept'
}];
exports.GIFT_ACTIONS_LIST = GIFT_ACTIONS_LIST;